import { Typography } from '@dapp/multi-lib/sdaoui/Typography';
import React from 'react';

type MenuGroupProps = {
  children: React.ReactNode;
};
export const MenuGroup = ({ children }: MenuGroupProps) => {
  return (
    <div className='pt-5'>
      <div className='gap flex flex-col items-start gap-2'>{children}</div>
    </div>
  );
};

export const MenuGroupLabel = ({ children }: { children: React.ReactNode }) => {
  return (
    <Typography className='text-xs font-normal tracking-normal text-grey-100'>
      {children}
    </Typography>
  );
};
